<app-page [simpleTopBar]="globalVars.isMobile()" title="Quote Reposts">
  <quote-reposts-details></quote-reposts-details>
</app-page>
